import Ext from 'Ext'
import PickerItem from './at_picker_item'
import SpecialMenuMgr from '../at_specialMenuMgr'

Ext.namespace('AT.menu');

const PickerMenu = Ext.extend(Ext.menu.DateMenu, {

    constructor : function(config, picker)
    {
        Ext.menu.DateMenu.superclass.constructor.call(this, config);

        this.picker = picker;
        this.plain = true;
        var di = new PickerItem( config, picker );
        this.add(di);

        this.on('beforeshow', function()
        {
            if (this.picker)
            {
                this.picker.hideMonthPicker(true);
            }
        }, this);


        this.picker.on("select", this.onDatePickerSelect, this);

        // Switch from the default MenuMgr to our special one.
        Ext.menu.MenuMgr.unregister(this);
        SpecialMenuMgr.register(this);
    }});

Ext.extend(PickerMenu, Ext.menu.Menu,
{
   cls:'x-date-menu',

   isHiding : false,
   selectionFinished : false,

   beforeDestroy : function()
   {
       this.picker.destroy();
   },

   show : function(el, pos, parentMenu)
   {
       this.selectionFinished = false;

       this.parentMenu = parentMenu;
       if (!this.el)
           this.render();

       if (!this.fireEvent("beforeshow", this)) return;
       this.showAt(this.el.getAlignToXY(el, pos || this.defaultAlign), parentMenu, false);

       this.isHiding = false;
   },

   // override
   hide : function(deep)
   {
       if (!this.isHiding)
       {
           var activeDate = this.picker.activeDate;
           if(activeDate)
           {
               this.picker.updateCells(activeDate);
           }
           this.isHiding = true;
           PickerMenu.superclass.hide.call(this, deep);
       }
   },

   onDatePickerSelect : function(picker, date)
   {
       this.selectionFinished = true;
       this.fireEvent("select", picker, date);
   }

});

export default PickerMenu



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/at_picker_menu.js